import { render, staticRenderFns } from "./unfixed.vue?vue&type=template&id=a9930eb0&"
import script from "./unfixed.vue?vue&type=script&lang=js&"
export * from "./unfixed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports